'use client';

import { SessionProvider } from 'next-auth/react';
const RNBSessionProvider = ({
  children
}) => {
  return <SessionProvider data-sentry-element="SessionProvider" data-sentry-component="RNBSessionProvider" data-sentry-source-file="SessionProvider.tsx">{children}</SessionProvider>;
};
export default RNBSessionProvider;